import styled from 'styled-components'
import { getArrowDown, getArrowUp, getCheckmark2 } from 'icons'
import { sc } from 'utils'

export default styled.span<{
  coverage?: boolean
  shortage?: boolean
  surplus?: boolean
  border?: boolean
  secondary?: boolean
  morningConsumption?: boolean
  afternoonConsumption?: boolean
  restConsumption?: boolean
}>`
  display: inline-flex;
  flex-direction: row;
  align-items: center;
  gap: 4px;

  width: fit-content;
  padding: 4px 8px;

  ${sc('secondary', '', 'color: var(--white);')}
  white-space: nowrap;
  font: var(--600-15);

  ${props => {
    if (props.secondary) return
    if (props.coverage) return 'background: var(--green);'
    if (props.shortage) return 'background: var(--red);'
    if (props.surplus) return 'background: var(--blue);'
    if (props.morningConsumption)
      return 'background: var(--light-blue-consumption); color: var(--dark-gray);'
    if (props.afternoonConsumption) return 'background: var(--blue-consumption);'
    if (props.restConsumption) return 'background: var(--dark-blue-consumption);'
    return 'background: var(--dark-gray);'
  }}

  ${sc('border', 'border: 1px solid;')}
  border-radius: 4px;

  ::before {
    height: 20px;

    ${props => {
      const color = props.secondary ? '%23424768' : 'white'
      if (props.coverage) return `content: url(${getCheckmark2(color)});`
      if (props.shortage) return `content: url(${getArrowDown(color)});`
      if (props.surplus) return `content: url(${getArrowUp(color)});`
    }}
  }
`
